/* typeshyrt — TikTok feed interactions
   double-tap hearts · snap active state · quick add · share · detail + collection panels */
(function () {
  'use strict';

  var feed = document.querySelector('[data-ts-feed]');
  if (!feed) return;

  var isTouch = window.matchMedia('(max-width: 749px)');
  var heartLayer = null;
  var pushedState = false;

  /* ───────────────────────── pinch-zoom awareness ─────────────────────────
     Browser pinch-zoom changes the *visual viewport* scale — it isn't a scroll and fires no scroll event.
     The feed is the only scroller on this page, so unless it steps aside it fights the zoom:
       · the swipe handlers read one finger of a pinch as a sideways swipe and cancel the gesture
       · one-finger pans while zoomed scroll-snap a whole slide instead of moving around the zoomed view
     So: ignore gestures while zoomed or with 2+ fingers down, and flag <html> so the CSS can release the feed. */
  var vv = window.visualViewport;
  function isZoomed() { return !!vv && vv.scale > 1.01; }
  function syncZoom() { document.documentElement.classList.toggle('ts-zoomed', isZoomed()); }
  if (vv) { vv.addEventListener('resize', syncZoom); syncZoom(); }

  /* iOS < 16 has no overscroll-behavior: swallow a downward pull at the very top of the feed so it can't
     chain up to the browser's pull-to-refresh. everything newer is handled in CSS. */
  if (!(window.CSS && CSS.supports && CSS.supports('overscroll-behavior-y', 'contain'))) {
    var pullX = 0, pullY = null;
    feed.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) { pullX = e.touches[0].clientX; pullY = e.touches[0].clientY; } else { pullY = null; }
    }, { passive: true });
    feed.addEventListener('touchmove', function (e) {
      if (pullY === null || e.touches.length !== 1 || isZoomed()) return;
      var dy = e.touches[0].clientY - pullY, dx = Math.abs(e.touches[0].clientX - pullX);
      if (feed.scrollTop <= 0 && dy > 6 && dy > dx) e.preventDefault();
    }, { passive: false });
  }

  /* ───────────────────────── likes (localStorage) ───────────────────────── */

  var LIKES_KEY = 'ts-liked';

  function getLikes() {
    try { return new Set(JSON.parse(localStorage.getItem(LIKES_KEY)) || []); } catch (e) { return new Set(); }
  }

  function saveLikes(set) {
    try { localStorage.setItem(LIKES_KEY, JSON.stringify(Array.from(set))); } catch (e) {}
  }

  function setLiked(productId, liked) {
    var set = getLikes();
    if (liked) { set.add(String(productId)); } else { set.delete(String(productId)); }
    saveLikes(set);
  }

  function isLiked(productId) {
    return getLikes().has(String(productId));
  }

  /* one place that flips the heart, so the visual state and the screen-reader state can't drift apart */
  function setLikeUI(btn, liked) {
    btn.classList.toggle('is-liked', liked);
    btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
  }

  /* ───────────────────────── helpers ───────────────────────── */

  function money(cents) {
    var fmt = window.TS_MONEY_FORMAT || '${{amount}}';
    return fmt
      .replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2))
      .replace(/<[^>]+>/g, '');
  }

  function toast(msg, linkHref, linkText) {
    var el = document.querySelector('[data-ts-toast]');
    if (!el) return;
    el.innerHTML = '';
    el.appendChild(document.createTextNode(msg));
    if (linkHref) {
      el.appendChild(document.createTextNode('  '));
      var a = document.createElement('a');
      a.href = linkHref;
      a.textContent = linkText || 'view';
      el.appendChild(a);
    }
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-show'); });
    clearTimeout(el._t);
    el._t = setTimeout(function () {
      el.classList.remove('is-show');
      setTimeout(function () { el.hidden = true; }, 320);
    }, 5000);
  }

  function bumpCart(count) {
    document.querySelectorAll('[data-ts-cart-count]').forEach(function (c) {
      c.textContent = count;
      c.classList.toggle('is-empty', count < 1);
      c.classList.add('is-bumped');
      setTimeout(function () { c.classList.remove('is-bumped'); }, 220);
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { bumpCart(c.item_count); })
      .catch(function () {});
  }

  var _lockScrollY = 0;
  function lockScroll(on) {
    /* on mobile, locking overflow causes a viewport jump — anchor it */
    if (on) {
      _lockScrollY = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + _lockScrollY + 'px';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, _lockScrollY);
    }
  }

  /* ───────────────────────── skeleton + active slide ───────────────────────── */

  document.querySelectorAll('[data-ts-media]').forEach(function (media) {
    var img = media.querySelector('.ts-slide__img');
    if (!img) { media.classList.add('is-loaded'); return; }
    if (img.complete && img.naturalWidth) {
      media.classList.add('is-loaded');
    } else {
      img.addEventListener('load', function () { media.classList.add('is-loaded'); });
      img.addEventListener('error', function () { media.classList.add('is-loaded'); });
    }
  });

  var slides = Array.prototype.slice.call(feed.querySelectorAll('[data-ts-slide]'));

  function resetSlideImages(slide) {
    var strip = slide.querySelector('[data-ts-images]');
    if (!strip || strip.children.length <= 1) return;
    strip._tsIdx = 0;
    strip.classList.add('no-transition');
    strip.style.transform = 'translate3d(0%,0,0)';
    var dots = Array.prototype.slice.call(slide.querySelectorAll('.ts-slide__dot'));
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === 0); });
    requestAnimationFrame(function () { strip.classList.remove('no-transition'); });
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.6) {
          slides.forEach(function (s) {
            var wasActive = s.classList.contains('is-active');
            s.classList.toggle('is-active', s === e.target);
            if (wasActive && s !== e.target) resetSlideImages(s);
          });
        }
      });
    }, { root: feed, threshold: [0.6, 0.9] });
    slides.forEach(function (s) { io.observe(s); });
  }
  if (slides[0]) {
    slides[0].classList.add('is-active');
  }

  /* restore liked state from localStorage */
  (function () {
    var liked = getLikes();
    slides.forEach(function (slide) {
      var pid = slide.getAttribute('data-product-id');
      if (pid && liked.has(String(pid))) {
        var btn = slide.querySelector('[data-ts-like]');
        if (btn) setLikeUI(btn, true);
      }
    });
  })();

  /* ─── desktop: translate stacked slots in sync with feed scroll ─── */
  var _slotResetTimer = null;
  feed.addEventListener('scroll', function () {
    if (isTouch.matches) return;
    if (!detailPanel || detailPanel.hidden) return;
    var slots = detailPanel.querySelector('.ts-detail__slots');
    if (!slots) return;
    var slideH = slides[0] ? slides[0].offsetHeight : window.innerHeight;
    slots.style.transform = 'translateY(-' + (feed.scrollTop / slideH * window.innerHeight) + 'px)';
    /* debounce: reset slot scroll only after feed has snapped and settled */
    clearTimeout(_slotResetTimer);
    _slotResetTimer = setTimeout(function () {
      for (var i = 0; i < slots.children.length; i++) slots.children[i].scrollTop = 0;
    }, 150);
  }, { passive: true });

  /* ───────────────────────── progress line (2px, above the bottom bar): how far through the feed you are ───────────────────────── */
  (function () {
    var bar = document.querySelector('[data-ts-progress]');
    if (!bar) return;
    var raf = 0;
    function paint() {
      raf = 0;
      var total = feed.scrollHeight;
      var p = total > 0 ? (feed.scrollTop + feed.clientHeight) / total : 0;
      bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)).toFixed(4) + ')';
    }
    function queue() { if (!raf) raf = requestAnimationFrame(paint); }
    feed.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    paint();
  })();

  /* ───────────────────────── horizontal image swipe on slides ───────────────────────── */

  function initSlideSwipe(slide) {
    var strip = slide.querySelector('[data-ts-images]');
    if (!strip) return;
    var count = strip.children.length;
    if (count <= 1) return;

    var dots = Array.prototype.slice.call(slide.querySelectorAll('.ts-slide__dot'));
    strip._tsIdx = 0; /* store on element so resetSlideImages can sync it */
    var startX = 0, startY = 0, dragX = 0;
    var active = false, dir = null;

    var lastX = 0, lastT = 0, vel = 0; /* px per ms, for flicks */

    function goTo(n, ms) {
      strip._tsIdx = Math.max(0, Math.min(count - 1, n));
      strip.classList.remove('no-transition');
      strip.style.transitionDuration = (ms || 460) + 'ms';
      strip.style.transform = 'translate3d(' + (-strip._tsIdx * 100) + '%,0,0)';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === strip._tsIdx); });
    }

    function startDrag(x, y) {
      startX = x; startY = y;
      dragX = 0; active = true; dir = null;
      lastX = x; lastT = performance.now(); vel = 0;
      strip.classList.add('no-transition');
    }

    function moveDrag(x, y, preventDefault) {
      if (!active) return;
      var dx = x - startX;
      var dy = y - startY;
      if (!dir) {
        if (Math.abs(dx) > Math.abs(dy) + 6) dir = 'h';
        else if (Math.abs(dy) > Math.abs(dx) + 6) dir = 'v';
      }
      if (dir === 'h') {
        if (preventDefault) preventDefault();
        var now = performance.now(), dt = now - lastT;
        if (dt > 0) vel = vel * 0.6 + ((x - lastX) / dt) * 0.4; /* smoothed */
        lastX = x; lastT = now;
        dragX = dx;
        /* past the first / last photo the strip resists instead of stopping dead */
        var edge = (dx > 0 && strip._tsIdx === 0) || (dx < 0 && strip._tsIdx === count - 1);
        var eff = edge ? dx * 0.32 : dx;
        var pct = (-strip._tsIdx * 100) + (eff / (strip.offsetWidth || slide.offsetWidth) * 100);
        strip.style.transform = 'translate3d(' + pct + '%,0,0)';
      }
    }

    function endDrag() {
      if (!active) return;
      active = false;
      if (dir === 'h') {
        var w = strip.offsetWidth || slide.offsetWidth || 1;
        if (performance.now() - lastT > 90) vel = 0; /* finger stopped before lifting = no flick */
        var flick = Math.abs(vel) > 0.35;
        var next = strip._tsIdx;
        if ((dragX < -w * 0.2 || (flick && vel < 0)) && strip._tsIdx < count - 1) next++;
        else if ((dragX > w * 0.2 || (flick && vel > 0)) && strip._tsIdx > 0) next--;
        /* settle time from the distance left and the release speed: quick flicks land fast, slow drags glide */
        var left = next === strip._tsIdx ? Math.abs(dragX) : w - Math.abs(dragX);
        var ms = Math.max(240, Math.min(520, left / Math.max(Math.abs(vel), 0.9)));
        goTo(next, ms);
      } else {
        strip.classList.remove('no-transition');
      }
    }

    /* a second finger, a cancelled touch, or being zoomed in all mean "not an image swipe":
       drop the drag, snap the strip back, and (crucially) never preventDefault — that is what
       stopped the browser from pinch-zooming. */
    function abortDrag() {
      if (!active) return;
      active = false; dir = null; dragX = 0;
      goTo(strip._tsIdx);
    }

    /* ---- touch ---- */
    slide.addEventListener('touchstart', function (e) {
      if (e.touches.length > 1 || isZoomed()) { abortDrag(); return; }
      startDrag(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    slide.addEventListener('touchmove', function (e) {
      if (e.touches.length > 1 || isZoomed()) { abortDrag(); return; }
      moveDrag(e.touches[0].clientX, e.touches[0].clientY, function () { e.preventDefault(); });
    }, { passive: false });
    slide.addEventListener('touchend', endDrag);
    slide.addEventListener('touchcancel', abortDrag);

    /* ---- mouse drag (desktop) ---- */
    slide.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      startDrag(e.clientX, e.clientY);
      strip.style.cursor = 'grabbing';
      e.preventDefault(); /* prevent text selection while dragging */
    });
    window.addEventListener('mousemove', function (e) {
      if (!active || !slide.contains(strip)) return;
      moveDrag(e.clientX, e.clientY, null);
    });
    window.addEventListener('mouseup', function () {
      if (!active) return;
      strip.style.cursor = '';
      endDrag();
    });

    /* cursor hint */
    strip.style.cursor = 'grab';
  }

  slides.forEach(initSlideSwipe);

  /* ---- arrow keys: left/right cycle active slide images, up/down scroll feed ---- */
  document.addEventListener('keydown', function (e) {
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var active = feed.querySelector('.ts-slide.is-active');
    if (!active) return;
    var strip = active.querySelector('[data-ts-images]');
    if (!strip) return;
    var count = strip.children.length;
    var dots = Array.prototype.slice.call(active.querySelectorAll('.ts-slide__dot'));
    var cur = strip._tsIdx || 0;
    var next = Math.max(0, Math.min(count - 1, e.key === 'ArrowLeft' ? cur - 1 : cur + 1));
    strip._tsIdx = next;
    strip.classList.remove('no-transition');
    strip.style.transitionDuration = '460ms';
    strip.style.transform = 'translate3d(' + (-next * 100) + '%,0,0)';
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === next); });
  });

  /* ───────────────────────── floating hearts ───────────────────────── */

  var HEART = '<svg viewBox="0 0 24 24"><path d="M12 21.6l-1.7-1.55C4.6 14.9 1.5 12.07 1.5 8.6 1.5 5.78 3.7 3.6 6.5 3.6c1.6 0 3.14.74 4.13 1.92L12 6.9l1.37-1.38A5.34 5.34 0 0 1 17.5 3.6c2.8 0 5 2.18 5 5 0 3.47-3.1 6.3-8.8 11.46L12 21.6Z"/></svg>';

  function ensureLayer() {
    if (!heartLayer) {
      heartLayer = document.createElement('div');
      heartLayer.className = 'ts-heartlayer';
      document.body.appendChild(heartLayer);
    }
    return heartLayer;
  }

  function burstHearts(x, y) {
    var layer = ensureLayer();
    var h = document.createElement('div');
    h.className = 'ts-burst-heart';
    h.style.left = x + 'px';
    h.style.top = y + 'px';
    h.innerHTML = HEART;
    layer.appendChild(h);
    h.addEventListener('animationend', function () { h.remove(); });
    setTimeout(function () { if (h.parentNode) h.remove(); }, 1200);
  }

  /* ───────────────────────── rail actions ───────────────────────── */

  feed.addEventListener('click', function (e) {
    var like = e.target.closest('[data-ts-like]');
    if (like) {
      e.preventDefault(); e.stopPropagation();
      var liked = !like.classList.contains('is-liked');
      setLikeUI(like, liked);
      var slide = like.closest('[data-product-id]');
      if (slide) setLiked(slide.getAttribute('data-product-id'), liked);
      if (liked) {
        var r = like.getBoundingClientRect();
        burstHearts(r.left + r.width / 2, r.top + r.height / 2);
      }
      return;
    }

    var add = e.target.closest('[data-ts-add]');
    if (add) {
      e.preventDefault(); e.stopPropagation();
      quickAdd(add);
      return;
    }

    var share = e.target.closest('[data-ts-share]');
    if (share) {
      e.preventDefault(); e.stopPropagation();
      doShare(share);
      return;
    }

    var openD = e.target.closest('[data-ts-open-detail]');
    if (openD) {
      e.preventDefault(); e.stopPropagation();
      openDetail(openD.getAttribute('data-product-id'));
      return;
    }

    var openC = e.target.closest('[data-ts-open-collection]');
    if (openC) {
      e.preventDefault(); e.stopPropagation();
      openCollection(openC.getAttribute('data-collection-url'));
      return;
    }
  });

  function quickAdd(btn) {
    if (btn.getAttribute('data-soldout')) { toast('sold out — try another size'); return; }
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var title = btn.getAttribute('data-product-title') || 'item';
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        var label = btn.querySelector('[data-ts-add-label]');
        if (label) { label.textContent = 'added'; setTimeout(function () { label.textContent = 'cart'; }, 1600); }
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        refreshCartCount();
        toast('“' + title + '” added to bag', '/cart', 'go to cart →');
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        toast('couldn’t add — try again');
      });
  }

  function doShare(btn) {
    var url = btn.getAttribute('data-share-url');
    var title = btn.getAttribute('data-share-title') || 'typeshyrt';
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { toast('link copied'); })
        .catch(function () { toast(url); });
    } else {
      toast(url);
    }
  }

  /* ───────────────────────── product detail panel references ───────────────────────── */
  var detailPanel = document.querySelector('[data-ts-detail-panel]');
  var detailContent = document.querySelector('[data-ts-detail-content]');

  /* ───────────────────────── double-tap → hearts → detail ───────────────────────── */

  slides.forEach(function (slide) {
    var lastTap = 0, lx = 0, ly = 0;
    slide.addEventListener('click', function (e) {
      if (e.target.closest('.ts-slide__rail, .ts-slide__overlay, a, button')) return;
      var now = Date.now();
      var x = e.clientX, y = e.clientY;
      if (now - lastTap < 330 && Math.abs(x - lx) < 44 && Math.abs(y - ly) < 44) {
        lastTap = 0;
        burstHearts(x, y);

        /* mark the like button as liked */
        var likeBtn = slide.querySelector('[data-ts-like]');
        if (likeBtn) setLikeUI(likeBtn, true);
        var pid = slide.getAttribute('data-product-id');
        if (pid) setLiked(pid, true);

        /* if panel already open, don't reopen — just heart */
        if (detailPanel && !detailPanel.hidden) return;

        var id = slide.getAttribute('data-product-id');
        setTimeout(function () { openDetail(id); }, 360);
      } else {
        lastTap = now; lx = x; ly = y;
      }
    });
  });

  /* ───────────────────────── product detail panel ───────────────────────── */

  function openDetail(id) {
    if (!detailPanel || !detailContent || !id) return;

    if (!isTouch.matches) {
      /* desktop: render all products as stacked slots, scroll-linked to feed */
      buildDesktopPanel(id);
      showPanel(detailPanel);
      return;
    }

    /* mobile: skeleton → single product */
    var tpl = document.querySelector('template[data-ts-detail="' + id + '"]');
    if (!tpl) return;
    detailContent.innerHTML = '<div class="ts-detail__skeleton"><div class="ts-detail__skel-img ts-skel"></div><div class="ts-detail__skel-body"><div class="ts-skel ts-detail__skel-line" style="width:55%;height:28px;margin-bottom:16px"></div><div class="ts-skel ts-detail__skel-line" style="width:35%;height:18px;margin-bottom:32px"></div><div class="ts-skel ts-detail__skel-line" style="width:80%;height:12px;margin-bottom:8px"></div><div class="ts-skel ts-detail__skel-line" style="width:65%;height:12px;margin-bottom:8px"></div><div class="ts-skel ts-detail__skel-line" style="width:72%;height:12px"></div></div></div>';
    showPanel(detailPanel);
    setTimeout(function () {
      detailContent.innerHTML = '';
      detailContent.appendChild(tpl.content.cloneNode(true));
      wireDetail(detailContent);
    }, 120);
  }

  function buildDesktopPanel(activeId) {
    var slideH = slides[0] ? slides[0].offsetHeight : window.innerHeight;
    /* use window.innerHeight — same unit feed snaps on, avoids rounding drift */
    var slotH = window.innerHeight;
    var wrapper = document.createElement('div');
    wrapper.className = 'ts-detail__slots';
    detailContent.style.height = '100%'; /* prevent detailContent from adding offset */
    slides.forEach(function (slide) {
      var pid = slide.getAttribute('data-product-id');
      var slot = document.createElement('div');
      slot.className = 'ts-detail__slot';
      slot.style.height = slotH + 'px'; /* exact viewport height */
      var tpl = pid && document.querySelector('template[data-ts-detail="' + pid + '"]');
      if (tpl) {
        slot.appendChild(tpl.content.cloneNode(true));
        wireDetail(slot);
      }
      wrapper.appendChild(slot);
    });
    detailContent.innerHTML = '';
    detailContent.appendChild(wrapper);
    /* align to current feed position — same normalized formula as scroll listener */
    wrapper.style.transform = 'translateY(-' + (feed.scrollTop / slideH * slotH) + 'px)';
  }

  function wireDetail(root) {
    var variants = [];
    try {
      var js = root.querySelector('script[data-detail-variants]');
      if (js) variants = JSON.parse(js.textContent);
    } catch (err) {}

    var idField = root.querySelector('[data-detail-variant-id]');
    var addBtn = root.querySelector('[data-detail-add]');
    var addLabel = root.querySelector('[data-detail-add-label]');
    var priceEl = root.querySelector('[data-detail-price]');
    var radios = root.querySelectorAll('[data-detail-option]');

    function selected() {
      var opts = [];
      root.querySelectorAll('[data-detail-option]:checked').forEach(function (r) {
        opts[parseInt(r.dataset.detailOption, 10) - 1] = r.value;
      });
      return opts;
    }
    function update() {
      if (!variants.length) return;
      var opts = selected();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      if (idField) idField.value = match.id;
      if (addBtn) addBtn.disabled = !match.available;
      if (addLabel) addLabel.innerHTML = match.available
        ? '<span class="ts-detail__add-action">add to cart</span><span class="ts-detail__add-price">' + money(match.price) + '</span>'
        : '<span class="ts-detail__add-action">sold out</span><span class="ts-detail__add-price"></span>';
      if (priceEl) {
        var html = '';
        if (match.compare_at_price && match.compare_at_price > match.price) html += '<s>' + money(match.compare_at_price) + '</s> ';
        priceEl.innerHTML = html + money(match.price);
      }
    }
    radios.forEach(function (r) { r.addEventListener('change', update); });

    /* like button in the buy bar: same state as the heart on the slide */
    root.querySelectorAll('[data-detail-like]').forEach(function (b) {
      var pid = b.getAttribute('data-product-id');
      var paint = function (on) { b.classList.toggle('is-liked', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); };
      paint(isLiked(pid));
      b.addEventListener('click', function () {
        var on = !b.classList.contains('is-liked');
        paint(on);
        setLiked(pid, on);
        var sl = feed.querySelector('[data-ts-slide][data-product-id="' + pid + '"]');
        var fb = sl && sl.querySelector('[data-ts-like]');
        if (fb) setLikeUI(fb, on);
      });
    });

    /* gallery thumbs + swipe on main image */
    var mainImg = root.querySelector('[data-detail-main] img');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-detail-thumb]'));
    var detailIdx = 0;

    var imgBusy = false;
    var imgPending = null; /* latest src requested while busy */

    function swapImage(src) {
      imgBusy = true;
      if (!mainImg || !mainImg.parentNode) { imgBusy = false; return; }

      /* fade out current */
      mainImg.style.transition = 'opacity 0.15s ease';
      mainImg.style.opacity = '0';

      setTimeout(function () {
        /* replace the element entirely — mutating src/srcset is unreliable on mobile */
        var parent = mainImg.parentNode;
        if (!parent) { imgBusy = false; return; }

        var newImg = document.createElement('img');
        newImg.className = mainImg.className;
        newImg.alt = mainImg.alt || '';
        newImg.style.cssText = 'opacity:0;transition:opacity 0.2s ease;width:100%;height:100%;object-fit:contain;display:block;';
        newImg.src = src;

        parent.replaceChild(newImg, mainImg);
        mainImg = newImg; /* update closure reference */

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            mainImg.style.opacity = '1';
            setTimeout(function () {
              imgBusy = false;
              if (imgPending !== null) {
                var next = imgPending;
                imgPending = null;
                swapImage(next);
              }
            }, 220);
          });
        });
      }, 150);
    }

    function setDetailImage(idx) {
      detailIdx = Math.max(0, Math.min(thumbs.length - 1, idx));
      thumbs.forEach(function (x, i) { x.classList.toggle('is-active', i === detailIdx); });

      if (!mainImg || thumbs.length === 0) return;
      var full = thumbs[detailIdx].getAttribute('data-full');
      if (!full) return;

      if (imgBusy) {
        imgPending = full; /* queue it — will run after current swap finishes */
      } else {
        swapImage(full);
      }
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { setDetailImage(i); });
    });

    /* swipe on main image area */
    var mainArea = root.querySelector('[data-detail-main]');
    if (mainArea && thumbs.length > 1) {
      var dStartX = 0, dDragX = 0, dActive = false;
      mainArea.addEventListener('touchstart', function (e) {
        if (e.touches.length > 1 || isZoomed()) { dActive = false; return; } /* pinch / zoomed pan, not a swipe */
        dStartX = e.touches[0].clientX; dDragX = 0; dActive = true;
      }, { passive: true });
      mainArea.addEventListener('touchmove', function (e) {
        if (!dActive) return;
        if (e.touches.length > 1 || isZoomed()) { dActive = false; return; }
        dDragX = e.touches[0].clientX - dStartX;
      }, { passive: true });
      mainArea.addEventListener('touchend', function () {
        if (!dActive) return; dActive = false;
        if (dDragX < -50) setDetailImage(detailIdx + 1);
        else if (dDragX > 50) setDetailImage(detailIdx - 1);
      });
    }

    /* add to cart from detail */
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        var id = idField ? idField.value : null;
        if (!id) return;
        addBtn.disabled = true;
        var orig = addLabel ? addLabel.innerHTML : '';
        if (addLabel) addLabel.innerHTML = '<span class="ts-detail__add-action">adding…</span><span class="ts-detail__add-price"></span>';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () {
            if (addLabel) addLabel.innerHTML = '<span class="ts-detail__add-action">added ✓</span><span class="ts-detail__add-price"></span>';
            refreshCartCount();
            toast('added to bag', '/cart', 'go to cart →');
            setTimeout(function () { if (addLabel) addLabel.innerHTML = orig; addBtn.disabled = false; }, 1600);
          })
          .catch(function () {
            if (addLabel) addLabel.innerHTML = orig;
            addBtn.disabled = false;
            toast('couldn’t add — try again');
          });
      });
    }

    /* collection link inside detail */
    root.querySelectorAll('[data-ts-open-collection]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        openCollection(a.getAttribute('data-collection-url'));
      });
    });
  }

  /* ───────────────────────── collection profile panel ───────────────────────── */

  var collPanel = document.querySelector('[data-ts-coll-panel]');
  var collContent = document.querySelector('[data-ts-coll-content]');

  function openCollection(url) {
    if (!collPanel || !collContent || !url) { if (url) location.href = url; return; }
    collContent.innerHTML = '<div class="ts-collpanel__loading"><p class="ts-label ts-muted">loading…</p></div>';
    showPanel(collPanel);
    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var profile = doc.querySelector('.ts-profile');
        if (!profile) { location.href = url; return; }
        profile.classList.add('ts-in');        /* it ships with .ts-fade (opacity:0) — no scroll observer in the panel */
        collContent.innerHTML = '';
        collContent.appendChild(profile);
        wireCollectionPanel(collContent);
      })
      .catch(function () { location.href = url; });
  }

  function wireCollectionPanel(root) {
    /* tabs */
    var tabs = root.querySelectorAll('[data-ts-tab]');
    var panes = root.querySelectorAll('[data-ts-pane]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.getAttribute('data-ts-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panes.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-ts-pane') === name); });
      });
    });
    /* thumbnails: open detail if we have it in the feed, else navigate */
    root.querySelectorAll('[data-ts-grid-item]').forEach(function (item) {
      item.addEventListener('click', function (e) {
        var pid = item.getAttribute('data-product-id');
        if (pid && document.querySelector('template[data-ts-detail="' + pid + '"]')) {
          e.preventDefault();
          closePanel(collPanel, true);
          setTimeout(function () { openDetail(pid); }, 260);
        }
        /* otherwise allow the link to navigate to the product page */
      });
    });
  }

  /* ───────────────────────── panel open/close plumbing ───────────────────────── */

  function showPanel(panel) {
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    if (panel === detailPanel) document.body.classList.add('ts-detail-open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
    });
    if (!pushedState) {
      try { history.pushState({ tsPanel: true }, ''); pushedState = true; } catch (e) {}
    }
    var closeBtn = panel.querySelector('[data-ts-detail-close], [data-ts-coll-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closePanel(panel, fromPop) {
    if (!panel || panel.hidden) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (panel === detailPanel) document.body.classList.remove('ts-detail-open');
    setTimeout(function () {
      panel.hidden = true;
      var c = panel.querySelector('[data-ts-detail-content], [data-ts-coll-content]');
      if (c) c.innerHTML = '';
    }, 340);
    if (!anyPanelOpenExcept(panel)) lockScroll(false);
    if (!fromPop && pushedState) { pushedState = false; try { history.back(); } catch (e) {} }
    else if (fromPop) { pushedState = false; }
  }

  function anyPanelOpenExcept(except) {
    return [detailPanel, collPanel].some(function (p) { return p && p !== except && !p.hidden; });
  }

  function closeAll(fromPop) {
    [detailPanel, collPanel].forEach(function (p) { if (p && !p.hidden) closePanel(p, fromPop); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ts-detail-close]')) { closePanel(detailPanel); }
    if (e.target.closest('[data-ts-coll-close]')) { closePanel(collPanel); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(false);
  });

  window.addEventListener('popstate', function () {
    if (detailPanel && !detailPanel.hidden) closePanel(detailPanel, true);
    else if (collPanel && !collPanel.hidden) closePanel(collPanel, true);
  });

  /* swipe-down to close bottom sheet (mobile detail) */
  if (detailPanel) {
    var swipeSheet = detailPanel.querySelector('.ts-detail__sheet');
    var swipeStartY = 0, swipeDragging = false, swipeLocked = false;
    if (swipeSheet) {
      swipeSheet.addEventListener('touchstart', function (e) {
        /* 2+ fingers or zoomed in = pinch / pan, never a close gesture */
        swipeLocked = e.touches.length > 1 || isZoomed();
        if (swipeLocked || !isTouch.matches || swipeSheet.scrollTop > 4) { swipeDragging = false; return; }
        swipeStartY = e.touches[0].clientY;
        swipeDragging = false; /* don't commit until we know direction */
      }, { passive: true });

      swipeSheet.addEventListener('touchmove', function (e) {
        if (e.touches.length > 1 || isZoomed()) {
          /* a second finger landed mid-drag: abandon the close gesture and put the sheet back */
          swipeLocked = true;
          if (swipeDragging) { swipeDragging = false; swipeSheet.style.transition = ''; swipeSheet.style.transform = ''; }
          return;
        }
        if (swipeLocked) return;
        var dy = e.touches[0].clientY - swipeStartY;
        if (!swipeDragging) {
          /* determine direction on first meaningful move */
          if (Math.abs(dy) < 8) return;
          if (dy > 0 && swipeSheet.scrollTop <= 0) {
            swipeDragging = true; /* downward swipe at top = close gesture */
          } else {
            swipeStartY = e.touches[0].clientY; /* upward = let it scroll */
            return;
          }
        }
        if (swipeDragging && dy > 0) {
          e.preventDefault(); /* block scroll while doing close gesture */
          swipeSheet.style.transition = 'none';
          swipeSheet.style.transform = 'translateY(' + dy + 'px)';
        }
      }, { passive: false });

      swipeSheet.addEventListener('touchend', function (e) {
        if (!swipeDragging) return;
        swipeDragging = false;
        var dy = e.changedTouches[0].clientY - swipeStartY;
        swipeSheet.style.transition = '';
        swipeSheet.style.transform = '';
        if (dy > 100) closePanel(detailPanel);
      });

      swipeSheet.addEventListener('touchcancel', function () {
        if (!swipeDragging) return;
        swipeDragging = false;
        swipeSheet.style.transition = '';
        swipeSheet.style.transform = '';
      });
    }
  }

  /* ───────────────────────── welcome guide ─────────────────────────
     first visit only. The "double-tap to like" toast that used to pop on every visit is gone; the guide covers it. */

  (function () {
    var welcome = document.getElementById('ts-welcome');
    var STORAGE_KEY = 'ts_welcomed_v2';
    if (!welcome) return;

    function dismiss() {
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      welcome.classList.add('is-leaving');
      var gone = false;
      function rm() { if (gone) return; gone = true; welcome.remove(); }
      welcome.addEventListener('animationend', rm, { once: true });
      setTimeout(rm, 700); /* reduced motion: no animationend */
    }

    try {
      if (localStorage.getItem(STORAGE_KEY)) { welcome.remove(); return; }
    } catch (e) {}

    welcome.classList.add('is-ready');
    var cta = document.getElementById('ts-welcome-cta');
    if (cta) cta.addEventListener('click', function (e) { e.stopPropagation(); dismiss(); });
    /* tapping the dim area outside the card also closes it */
    welcome.addEventListener('click', function (e) { if (e.target === welcome) dismiss(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && document.getElementById('ts-welcome')) dismiss(); });
  })();


})();
